import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import NotificationModel from "./model/NotificationModel.js"
import { map } from 'rxjs/operators';

export default {
    apiGetNotification: function () {
        const token = Account.getToken();
        let params = {};
        const url = ConfigManager.getApiUrl() + `/noti?mode=full`;
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            console.log(res);
            let notis = [];
            for (let item of res.data) {
                let noti = new NotificationModel (item);
                notis.push(noti);
            }
            return notis;
        }));
    },
    apiReadNotification: function (rowKey) {
        const token = Account.getToken();
        let params = {
            ids: rowKey
        }
        const url = ConfigManager.getApiUrl() + `/noti/read`;
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiGetNotiBadge: function () {
        const token = Account.getToken();
        let params = {};
        const url = ConfigManager.getApiUrl() + `/noti?mode=full`;
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
}
